import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { type NewsletterRouteModel } from 'donor-elf-web/routes/funds/fund/more/newsletter';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class NewsletterConnectedController extends Controller {
  @service declare router: RouterService;

  model!: NewsletterRouteModel;

  @tracked removingSync = false;
  @tracked error?: any;

  @action
  templateWillDestroy() {
    this.removingSync = false;
    this.error = undefined;
  }

  @action
  async removeSync() {
    this.removingSync = true;
    try {
      await this.model.newsletterAccount?.destroyRecord();
      this.send('refreshNewsletterRoute');
    } catch (e) {
      this.error = e;
    }
  }
}
